import { render, staticRenderFns } from "./EditTemplateDialog.vue?vue&type=template&id=2469c824&scoped=true&"
import script from "./EditTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469c824",
  null
  
)

export default component.exports